exports = module.exports = require("../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".spinner-line,.spinner-wrap{position:fixed;background:0 0}.spinner-wrap{top:0;left:0;width:100%;height:100%;z-index:10000}.spinner-line{top:50%;left:50%;transform:translate(-50%,-50%);z-index:10001}\n", ""]);

